export const itemsSelect = {

    admin_search_commandes_by_mode() {
        let list = [];
        list.push({ title: "Email de l'utilisateur", value: "email" });
        list.push({ title: "Nom de l'inscrit", value: "nom" });
        list.push({ title: "UUID de la commande", value: "uuid" });
        list.push({ title: "ID de l'utilisateur", value: "id_user" });
        return list;
    },
    admin_search_refund_commandes_by_mode() {
        let list = [];
        list.push({ title: "Email de l'utilisateur", value: "email" });
        list.push({ title: "Nom de l'inscrit", value: "nom" });
        list.push({ title: "UUID de la commande", value: "uuid" });
        return list;
    },
    refund_fee_payed_by() {
        let list = [];
        list.push({ title: "Organisateur", value: "orga" });
        list.push({ title: "Participant", value: "participant" });
        return list;
    },

    order_by_select() {
        let list = [];
        list.push({ title: "Nom", value: "nom" });
        list.push({ title: "Dossard", value: "dossard" });
        list.push({ title: "Club", value: "club" });
        return list;
    },

    getSelection(options, is_ffrp = false) {
        let list = [];
        let list_options = options.split(";");
        if (list_options.length > 0 && !list_options[0].includes("Sélect")) {
            list.push({ title: "Sélectionner", value: "" });
        }

        for (let i = 0; i < list_options.length; i++) {
            if (is_ffrp && is_ffrp == '1' && list_options[i] == 'Licence') {
                list.push({ title: list_options[i] + " FFRP", value: list_options[i] });
            }
            else {
                list.push({ title: list_options[i], value: list_options[i] });
            }
        }
        return list;
    },

    sexe() {
        let list_sexe = [];
        list_sexe.push({ title: "Homme", value: "M" });
        list_sexe.push({ title: "Femme", value: "F" });
        return list_sexe;
    },
    mode_livraison() {
        let list_mode_livraison = [];
        list_mode_livraison.push({ title: "Retrait sur place", value: "retrait" });
        list_mode_livraison.push({ title: "Retrait en point relais pickup", value: "point_relai" });
        return list_mode_livraison;
    },

    options_days() {
        let list_days = [
            { label: "01", value: "01" },
            { label: "02", value: "02" },
            { label: "03", value: "03" },
            { label: "04", value: "04" },
            { label: "05", value: "05" },
            { label: "06", value: "06" },
            { label: "07", value: "07" },
            { label: "08", value: "08" },
            { label: "09", value: "09" },
            { label: "10", value: "10" },
            { label: "11", value: "11" },
            { label: "12", value: "12" },
            { label: "13", value: "13" },
            { label: "14", value: "14" },
            { label: "15", value: "15" },
            { label: "16", value: "16" },
            { label: "17", value: "17" },
            { label: "18", value: "18" },
            { label: "19", value: "19" },
            { label: "20", value: "20" },
            { label: "21", value: "21" },
            { label: "22", value: "22" },
            { label: "23", value: "23" },
            { label: "24", value: "24" },
            { label: "25", value: "25" },
            { label: "26", value: "26" },
            { label: "27", value: "27" },
            { label: "28", value: "28" },
            { label: "29", value: "29" },
            { label: "30", value: "30" },
            { label: "31", value: "31" }
        ];
        return list_days;
    },
    options_months() {
        let list_months = [
            { label: "Janvier", value: "01" },
            { label: "Février", value: "02" },
            { label: "Mars", value: "03" },
            { label: "Avril", value: "04" },
            { label: "Mai", value: "05" },
            { label: "Juin", value: "06" },
            { label: "Juillet", value: "07" },
            { label: "Août", value: "08" },
            { label: "Septembre", value: "09" },
            { label: "Octobre", value: "10" },
            { label: "Novembre", value: "11" },
            { label: "Décembre", value: "12" }
        ]
        return list_months;
    },

    options_years() {
        let list_years = [];
        let current_year = new Date().getFullYear();
        for (let i = current_year; i > 1900; i--) {
            list_years.push({ label: i, value: i });
        }
        return list_years;
    },

    pays() {
        let list_pays = [
            {
                "title": "Afghanistan",
                "value": "AFG"
            },
            {
                "title": "Albanie",
                "value": "ALB"
            },
            {
                "title": "Antarctique",
                "value": "ATA"
            },
            {
                "title": "Algérie",
                "value": "DZA"
            },
            {
                "title": "Samoa Américaines",
                "value": "ASM"
            },
            {
                "title": "Andorre",
                "value": "AND"
            },
            {
                "title": "Angola",
                "value": "AGO"
            },
            {
                "title": "Antigua-et-Barbuda",
                "value": "ATG"
            },
            {
                "title": "Azerbaïdjan",
                "value": "AZE"
            },
            {
                "title": "Argentine",
                "value": "ARG"
            },
            {
                "title": "Australie",
                "value": "AUS"
            },
            {
                "title": "Autriche",
                "value": "AUT"
            },
            {
                "title": "Bahamas",
                "value": "BHS"
            },
            {
                "title": "Bahreïn",
                "value": "BHR"
            },
            {
                "title": "Bangladesh",
                "value": "BGD"
            },
            {
                "title": "Arménie",
                "value": "ARM"
            },
            {
                "title": "Barbade",
                "value": "BRB"
            },
            {
                "title": "Belgique",
                "value": "BEL"
            },
            {
                "title": "Bermudes",
                "value": "BMU"
            },
            {
                "title": "Bhoutan",
                "value": "BTN"
            },
            {
                "title": "Bolivie",
                "value": "BOL"
            },
            {
                "title": "Bosnie-Herzégovine",
                "value": "BIH"
            },
            {
                "title": "Botswana",
                "value": "BWA"
            },
            {
                "title": "Île Bouvet",
                "value": "BVT"
            },
            {
                "title": "Brésil",
                "value": "BRA"
            },
            {
                "title": "Belize",
                "value": "BLZ"
            },
            {
                "title": "Territoire Britannique de l'Océan Indien",
                "value": "IOT"
            },
            {
                "title": "Îles Salomon",
                "value": "SLB"
            },
            {
                "title": "Îles Vierges Britanniques",
                "value": "VGB"
            },
            {
                "title": "Brunéi Darussalam",
                "value": "BRN"
            },
            {
                "title": "Bulgarie",
                "value": "BGR"
            },
            {
                "title": "Myanmar",
                "value": "MMR"
            },
            {
                "title": "Burundi",
                "value": "BDI"
            },
            {
                "title": "Bélarus",
                "value": "BLR"
            },
            {
                "title": "Cambodge",
                "value": "KHM"
            },
            {
                "title": "Cameroun",
                "value": "CMR"
            },
            {
                "title": "Canada",
                "value": "CAN"
            },
            {
                "title": "Cap-vert",
                "value": "CPV"
            },
            {
                "title": "Îles Caïmanes",
                "value": "CYM"
            },
            {
                "title": "République Centrafricaine",
                "value": "CAF"
            },
            {
                "title": "Sri Lanka",
                "value": "LKA"
            },
            {
                "title": "Tchad",
                "value": "TCD"
            },
            {
                "title": "Chili",
                "value": "CHL"
            },
            {
                "title": "Chine",
                "value": "CHN"
            },
            {
                "title": "Taïwan",
                "value": "TWN"
            },
            {
                "title": "Île Christmas",
                "value": "CXR"
            },
            {
                "title": "Îles Cocos (Keeling)",
                "value": "CCK"
            },
            {
                "title": "Colombie",
                "value": "COL"
            },
            {
                "title": "Comores",
                "value": "COM"
            },
            {
                "title": "Mayotte",
                "value": "MYT"
            },
            {
                "title": "République du Congo",
                "value": "COG"
            },
            {
                "title": "République Démocratique du Congo",
                "value": "COD"
            },
            {
                "title": "Îles Cook",
                "value": "COK"
            },
            {
                "title": "Costa Rica",
                "value": "CRI"
            },
            {
                "title": "Croatie",
                "value": "HRV"
            },
            {
                "title": "Cuba",
                "value": "CUB"
            },
            {
                "title": "Chypre",
                "value": "CYP"
            },
            {
                "title": "République Tchèque",
                "value": "CZE"
            },
            {
                "title": "Bénin",
                "value": "BEN"
            },
            {
                "title": "Danemark",
                "value": "DNK"
            },
            {
                "title": "Dominique",
                "value": "DMA"
            },
            {
                "title": "République Dominicaine",
                "value": "DOM"
            },
            {
                "title": "Équateur",
                "value": "ECU"
            },
            {
                "title": "El Salvador",
                "value": "SLV"
            },
            {
                "title": "Guinée Équatoriale",
                "value": "GNQ"
            },
            {
                "title": "Éthiopie",
                "value": "ETH"
            },
            {
                "title": "Érythrée",
                "value": "ERI"
            },
            {
                "title": "Estonie",
                "value": "EST"
            },
            {
                "title": "Îles Féroé",
                "value": "FRO"
            },
            {
                "title": "Îles (malvinas) Falkland",
                "value": "FLK"
            },
            {
                "title": "Géorgie du Sud et les Îles Sandwich du Sud",
                "value": "SGS"
            },
            {
                "title": "Fidji",
                "value": "FJI"
            },
            {
                "title": "Finlande",
                "value": "FIN"
            },
            {
                "title": "Îles Åland",
                "value": "ALA"
            },
            {
                "title": "France",
                "value": "FRA"
            },
            {
                "title": "Guyane Française",
                "value": "GUF"
            },
            {
                "title": "Polynésie Française",
                "value": "PYF"
            },
            {
                "title": "Terres Australes Françaises",
                "value": "ATF"
            },
            {
                "title": "Djibouti",
                "value": "DJI"
            },
            {
                "title": "Gabon",
                "value": "GAB"
            },
            {
                "title": "Géorgie",
                "value": "GEO"
            },
            {
                "title": "Gambie",
                "value": "GMB"
            },
            {
                "title": "Territoire Palestinien Occupé",
                "value": "PSE"
            },
            {
                "title": "Allemagne",
                "value": "DEU"
            },
            {
                "title": "Ghana",
                "value": "GHA"
            },
            {
                "title": "Gibraltar",
                "value": "GIB"
            },
            {
                "title": "Kiribati",
                "value": "KIR"
            },
            {
                "title": "Grèce",
                "value": "GRC"
            },
            {
                "title": "Groenland",
                "value": "GRL"
            },
            {
                "title": "Grenade",
                "value": "GRD"
            },
            {
                "title": "Guadeloupe",
                "value": "GLP"
            },
            {
                "title": "Guam",
                "value": "GUM"
            },
            {
                "title": "Guatemala",
                "value": "GTM"
            },
            {
                "title": "Guinée",
                "value": "GIN"
            },
            {
                "title": "Guyana",
                "value": "GUY"
            },
            {
                "title": "Haïti",
                "value": "HTI"
            },
            {
                "title": "Îles Heard et Mcdonald",
                "value": "HMD"
            },
            {
                "title": "Saint-Siège (état de la Cité du Vatican)",
                "value": "VAT"
            },
            {
                "title": "Honduras",
                "value": "HND"
            },
            {
                "title": "Hong-Kong",
                "value": "HKG"
            },
            {
                "title": "Hongrie",
                "value": "HUN"
            },
            {
                "title": "Islande",
                "value": "ISL"
            },
            {
                "title": "Inde",
                "value": "IND"
            },
            {
                "title": "Indonésie",
                "value": "IDN"
            },
            {
                "title": "République Islamique d'Iran",
                "value": "IRN"
            },
            {
                "title": "Iraq",
                "value": "IRQ"
            },
            {
                "title": "Irlande",
                "value": "IRL"
            },
            {
                "title": "Israël",
                "value": "ISR"
            },
            {
                "title": "Italie",
                "value": "ITA"
            },
            {
                "title": "Côte d'Ivoire",
                "value": "CIV"
            },
            {
                "title": "Jamaïque",
                "value": "JAM"
            },
            {
                "title": "Japon",
                "value": "JPN"
            },
            {
                "title": "Kazakhstan",
                "value": "KAZ"
            },
            {
                "title": "Jordanie",
                "value": "JOR"
            },
            {
                "title": "Kenya",
                "value": "KEN"
            },
            {
                "title": "République Populaire Démocratique de Corée",
                "value": "PRK"
            },
            {
                "title": "République de Corée",
                "value": "KOR"
            },
            {
                "title": "Koweït",
                "value": "KWT"
            },
            {
                "title": "Kirghizistan",
                "value": "KGZ"
            },
            {
                "title": "République Démocratique Populaire Lao",
                "value": "LAO"
            },
            {
                "title": "Liban",
                "value": "LBN"
            },
            {
                "title": "Lesotho",
                "value": "LSO"
            },
            {
                "title": "Lettonie",
                "value": "LVA"
            },
            {
                "title": "Libéria",
                "value": "LBR"
            },
            {
                "title": "Jamahiriya Arabe Libyenne",
                "value": "LBY"
            },
            {
                "title": "Liechtenstein",
                "value": "LIE"
            },
            {
                "title": "Lituanie",
                "value": "LTU"
            },
            {
                "title": "Luxembourg",
                "value": "LUX"
            },
            {
                "title": "Macao",
                "value": "MAC"
            },
            {
                "title": "Madagascar",
                "value": "MDG"
            },
            {
                "title": "Malawi",
                "value": "MWI"
            },
            {
                "title": "Malaisie",
                "value": "MYS"
            },
            {
                "title": "Maldives",
                "value": "MDV"
            },
            {
                "title": "Mali",
                "value": "MLI"
            },
            {
                "title": "Malte",
                "value": "MLT"
            },
            {
                "title": "Martinique",
                "value": "MTQ"
            },
            {
                "title": "Mauritanie",
                "value": "MRT"
            },
            {
                "title": "Maurice",
                "value": "MUS"
            },
            {
                "title": "Mexique",
                "value": "MEX"
            },
            {
                "title": "Monaco",
                "value": "MCO"
            },
            {
                "title": "Mongolie",
                "value": "MNG"
            },
            {
                "title": "République de Moldova",
                "value": "MDA"
            },
            {
                "title": "Montserrat",
                "value": "MSR"
            },
            {
                "title": "Maroc",
                "value": "MAR"
            },
            {
                "title": "Mozambique",
                "value": "MOZ"
            },
            {
                "title": "Oman",
                "value": "OMN"
            },
            {
                "title": "Namibie",
                "value": "NAM"
            },
            {
                "title": "Nauru",
                "value": "NRU"
            },
            {
                "title": "Népal",
                "value": "NPL"
            },
            {
                "title": "Pays-Bas",
                "value": "NLD"
            },
            {
                "title": "Antilles Néerlandaises",
                "value": "ANT"
            },
            {
                "title": "Aruba",
                "value": "ABW"
            },
            {
                "title": "Nouvelle-Calédonie",
                "value": "NCL"
            },
            {
                "title": "Vanuatu",
                "value": "VUT"
            },
            {
                "title": "Nouvelle-Zélande",
                "value": "NZL"
            },
            {
                "title": "Nicaragua",
                "value": "NIC"
            },
            {
                "title": "Niger",
                "value": "NER"
            },
            {
                "title": "Nigéria",
                "value": "NGA"
            },
            {
                "title": "Niué",
                "value": "NIU"
            },
            {
                "title": "Île Norfolk",
                "value": "NFK"
            },
            {
                "title": "Norvège",
                "value": "NOR"
            },
            {
                "title": "Îles Mariannes du Nord",
                "value": "MNP"
            },
            {
                "title": "Îles Mineures Éloignées des États-Unis",
                "value": "UMI"
            },
            {
                "title": "États Fédérés de Micronésie",
                "value": "FSM"
            },
            {
                "title": "Îles Marshall",
                "value": "MHL"
            },
            {
                "title": "Palaos",
                "value": "PLW"
            },
            {
                "title": "Pakistan",
                "value": "PAK"
            },
            {
                "title": "Panama",
                "value": "PAN"
            },
            {
                "title": "Papouasie-Nouvelle-Guinée",
                "value": "PNG"
            },
            {
                "title": "Paraguay",
                "value": "PRY"
            },
            {
                "title": "Pérou",
                "value": "PER"
            },
            {
                "title": "Philippines",
                "value": "PHL"
            },
            {
                "title": "Pitcairn",
                "value": "PCN"
            },
            {
                "title": "Pologne",
                "value": "POL"
            },
            {
                "title": "Portugal",
                "value": "PRT"
            },
            {
                "title": "Guinée-Bissau",
                "value": "GNB"
            },
            {
                "title": "Timor-Leste",
                "value": "TLS"
            },
            {
                "title": "Porto Rico",
                "value": "PRI"
            },
            {
                "title": "Qatar",
                "value": "QAT"
            },
            {
                "title": "Réunion",
                "value": "REU"
            },
            {
                "title": "Roumanie",
                "value": "ROU"
            },
            {
                "title": "Fédération de Russie",
                "value": "RUS"
            },
            {
                "title": "Rwanda",
                "value": "RWA"
            },
            {
                "title": "Sainte-Hélène",
                "value": "SHN"
            },
            {
                "title": "Saint-Kitts-et-Nevis",
                "value": "KNA"
            },
            {
                "title": "Anguilla",
                "value": "AIA"
            },
            {
                "title": "Sainte-Lucie",
                "value": "LCA"
            },
            {
                "title": "Saint-Pierre-et-Miquelon",
                "value": "SPM"
            },
            {
                "title": "Saint-Vincent-et-les Grenadines",
                "value": "VCT"
            },
            {
                "title": "Saint-Marin",
                "value": "SMR"
            },
            {
                "title": "Sao Tomé-et-Principe",
                "value": "STP"
            },
            {
                "title": "Arabie Saoudite",
                "value": "SAU"
            },
            {
                "title": "Sénégal",
                "value": "SEN"
            },
            {
                "title": "Seychelles",
                "value": "SYC"
            },
            {
                "title": "Sierra Leone",
                "value": "SLE"
            },
            {
                "title": "Singapour",
                "value": "SGP"
            },
            {
                "title": "Slovaquie",
                "value": "SVK"
            },
            {
                "title": "Viet Nam",
                "value": "VNM"
            },
            {
                "title": "Slovénie",
                "value": "SVN"
            },
            {
                "title": "Somalie",
                "value": "SOM"
            },
            {
                "title": "Afrique du Sud",
                "value": "ZAF"
            },
            {
                "title": "Zimbabwe",
                "value": "ZWE"
            },
            {
                "title": "Espagne",
                "value": "ESP"
            },
            {
                "title": "Sahara Occidental",
                "value": "ESH"
            },
            {
                "title": "Soudan",
                "value": "SDN"
            },
            {
                "title": "Suriname",
                "value": "SUR"
            },
            {
                "title": "Svalbard etÎle Jan Mayen",
                "value": "SJM"
            },
            {
                "title": "Swaziland",
                "value": "SWZ"
            },
            {
                "title": "Suède",
                "value": "SWE"
            },
            {
                "title": "Suisse",
                "value": "CHE"
            },
            {
                "title": "République Arabe Syrienne",
                "value": "SYR"
            },
            {
                "title": "Tadjikistan",
                "value": "TJK"
            },
            {
                "title": "Thaïlande",
                "value": "THA"
            },
            {
                "title": "Togo",
                "value": "TGO"
            },
            {
                "title": "Tokelau",
                "value": "TKL"
            },
            {
                "title": "Tonga",
                "value": "TON"
            },
            {
                "title": "Trinité-et-Tobago",
                "value": "TTO"
            },
            {
                "title": "Émirats Arabes Unis",
                "value": "ARE"
            },
            {
                "title": "Tunisie",
                "value": "TUN"
            },
            {
                "title": "Turquie",
                "value": "TUR"
            },
            {
                "title": "Turkménistan",
                "value": "TKM"
            },
            {
                "title": "Îles Turks et Caïques",
                "value": "TCA"
            },
            {
                "title": "Tuvalu",
                "value": "TUV"
            },
            {
                "title": "Ouganda",
                "value": "UGA"
            },
            {
                "title": "Ukraine",
                "value": "UKR"
            },
            {
                "title": "L'ex-République Yougoslave de Macédoine",
                "value": "MKD"
            },
            {
                "title": "Égypte",
                "value": "EGY"
            },
            {
                "title": "Royaume-Uni",
                "value": "GBR"
            },
            {
                "title": "Île de Man",
                "value": "IMN"
            },
            {
                "title": "République-Unie de Tanzanie",
                "value": "TZA"
            },
            {
                "title": "États-Unis",
                "value": "USA"
            },
            {
                "title": "Îles Vierges des États-Unis",
                "value": "VIR"
            },
            {
                "title": "Burkina Faso",
                "value": "BFA"
            },
            {
                "title": "Uruguay",
                "value": "URY"
            },
            {
                "title": "Ouzbékistan",
                "value": "UZB"
            },
            {
                "title": "Venezuela",
                "value": "VEN"
            },
            {
                "title": "Wallis et Futuna",
                "value": "WLF"
            },
            {
                "title": "Samoa",
                "value": "WSM"
            },
            {
                "title": "Yémen",
                "value": "YEM"
            },
            {
                "title": "Serbie-et-Monténégro",
                "value": "SCG"
            },
            {
                "title": "Zambie",
                "value": "ZMB"
            }
        ]
        return list_pays;
    },
}

